import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderLink2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFolderLink2"><Path fillRule="evenodd" clipRule="evenodd" d="M5 16H9V18H5V16Z" fill="currentColor"/><Path d="M2 3H10.5352L12.5352 6H22V20H15V11H2V3Z" fill="currentColor"/><Path d="M1 13V21H6V19H3V15H6V13H1Z" fill="currentColor"/><Path d="M13 13V21H8V19H11V15H8V13H13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolderLink2;
